import styled from 'styled-components';

import { ThemeType } from '../theme/Theme';
import { Flex } from './Flex';
import { Spinner } from './Spinner';

const Container = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: auto;
`;

type SpinnerFullScreenProps = {
  color?: keyof ThemeType;
};

export const SpinnerFullScreen: React.FC<SpinnerFullScreenProps> = ({
  color,
}) => {
  return (
    <Container>
      <Flex width={'3rem'} height={'3rem'}>
        <Spinner color={color} />
      </Flex>
    </Container>
  );
};
